import { FeatureFlag } from '../feature-flag/feature-flag'

export const trackEvent = (event: string, data?: Record<string, unknown>) => {
  const experiments = FeatureFlag.Helper.getExperiments()
  track({ event, _clear: true, ...data, experiments })
}

export const track = (data: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
  localStorage &&
    localStorage.getItem('debugDataLayer') == 'true' &&
    console.debug(JSON.stringify(data, null, 2))
}
